import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetDienstleistungListeMutation } from '../../../api/StammdatenAPI';
import { IDienstleistung } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';

export default function AbzurechnnendeDlMain() {

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<IDienstleistung[]>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [getDienstleistungListeAPI] = useGetDienstleistungListeMutation();

  const init = () => {
    getDienstleistungListeAPI().unwrap()
      .then(data => setListe(data))
      .then(() => setLoaded(true))
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate({
                pathname: "/",
                search: ""
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          >
            <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Dienstleistungen</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('detail', { state: { view: 'create' } })}><i className="bi bi-plus"></i><span style={{ marginLeft: "1em" }}>NEU ANLEGEN</span></button>
          <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "2fr 2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
            <div>Name</div>
            <div>Erledigungsart</div>
            <div style={{ textAlign: "end" }}>
              Option
            </div>
          </div>
          {
            (isLoaded && liste?.map((e, index) =>
              <div key={index} style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                <div>{e.text}</div>
                <div>{e.erledigungsart}</div>
                <div style={{ textAlign: "end" }}>
                  <button onClick={() => navigate('detail', { state: { view: 'detail', id: e.uid } })} className={styles["wg-a"]} ><i className="bi bi-pencil"></i></button>
                </div>
              </div>)
            )
          }
          {(!isLoaded && <>Lädt...</>)}
        </div>
      </div>

    </>
  );
}